module.exports = __webpack_public_path__ + "static/media/00_php_database_website_card.8d0b9b66.png";